import { usePlanGroupFacade } from '@ctct/state-server-layer';

export const usePlanIdForSmsBundleAddOns = ({
  selectedEmailPlanId,
  isSmsBundle,
}: {
  selectedEmailPlanId: number | null | undefined;
  isSmsBundle: boolean;
}): number | null => {
  const planGroupQuery = usePlanGroupFacade();

  if (selectedEmailPlanId != null) {
    return selectedEmailPlanId;
  }

  if (!isSmsBundle || !planGroupQuery.data) {
    return null;
  }

  const recommendedOrFirstPlanId =
    planGroupQuery.data.getRecommendedPlanId() ?? planGroupQuery.data.getAllDisplayedPlans()[0]?.getId() ?? null;

  return typeof recommendedOrFirstPlanId === 'number' ? recommendedOrFirstPlanId : null;
};
